import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { POADocumentType } from '@e-origin/shared';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

interface GenerateDocumentProps {
  importerId: string;
  type: POADocumentType;
}

export const useGenerateDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ importerId, type }: GenerateDocumentProps) => {
      return request({
        path: `importer/generate-document/${importerId}/${type}`,
        method: 'POST',
        authenticate: true,
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['importer', variables.importerId] });
      toast.success(`${variables.type} document generated!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error generating document!`);
    },
  });
};
